import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import './Pesquisar.css';
import { Button, Spin } from 'antd';
import { useConfigQuery } from '../../../queries/useConfig';
import { api } from '../../../config/api';

const Pesquisar = ({ onItemPress, closeModal, setPagamentoConcluido, setPagamentos, validarEstoque }) => {
  // validarEstoque da prop é para telas que não necessite de validação usarem como false

  const dispatch = useDispatch();
  const { data: config, error } = useConfigQuery();
  const [searchTerm, setSearchTerm] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");

  // currentPage representa a próxima página a ser carregada
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);


  // Refs para o container de scroll e para o elemento trigger
  const containerRef = useRef(null);
  const targetRef = useRef(null);


  const handleItemPress = item => {
    item.quantidade = 1;
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;
    item.idVendedor = idUser;
    onItemPress(item);
    closeModal();
    setPagamentoConcluido(false);
    setPagamentos([]);
  };

  // Função que carrega produtos a partir da página informada
  const loadProducts = useCallback(
    async (pageToLoad) => {
      if (!accessToken || !config?.restaurante?.id || (!searchTerm && config?.terminalComercial?.pesquisaLivre == false)) return;
      // Se já atingiu ou ultrapassou a última página, não carrega
      if (pageToLoad >= totalPages) return;

      setIsLoading(true);
      try {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        };
        let response = {};
        if (searchTerm == '') {
          response = await axios.post(
            `${api.techspdv}/v1/restaurantes/${config?.restaurante?.id}/produtos/eancodnome?page=${pageToLoad}`, { texto: '' },
            options
          );

        } else {
          response = await axios.post(
            `${api.techspdv}/v1/restaurantes/${config?.restaurante?.id}/produtos/eancodnome?page=${pageToLoad}`, { texto: searchTerm },
            options
          );
        }
        const produtos = response.data._embedded?.produtos || [];
        const { number, totalPages: total } = response.data.page;
        setTotalPages(total);

        if (pageToLoad === 0) {
          // Primeira página: substitui os produtos
          setProducts(produtos);
        } else {
          // Páginas seguintes: anexa os novos produtos
          setProducts(prev => [...prev, ...produtos]);
        }

        // Atualiza para a próxima página
        const nextPage = number + 1;
        setCurrentPage(nextPage);
      } catch (error) {
        console.error('Erro ao carregar produtos:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [accessToken, searchTerm, totalPages, config]
  );

  // Acionado ao clicar no botão "Pesquisar"
  const handleSearch = () => {
    console.log('cliquei em pesquisar');
    // Reinicia os estados para nova pesquisa

    setProducts([]);
    setCurrentPage(0);
    setTotalPages(1);
    setHasSearched(true);
    loadProducts(0);

  };

  // Intersection Observer para carregar páginas extras quando o fim do container for alcançado
  useEffect(() => {
    // Só ativa se já houve uma pesquisa
    if (!hasSearched || !containerRef.current) return;

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && !isLoading && currentPage < totalPages) {
          loadProducts(currentPage);
        }
      },
      { root: containerRef.current, threshold: 0.1 }
    );

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [hasSearched, isLoading, currentPage, totalPages, loadProducts]);

  const renderItem = item => {
    const formattedPrice = item.preco.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    return (
      <div
        className="card"
        onClick={() => { ((config?.terminalComercial?.gerenciaEstoque && parseFloat(item.quantidade_estoque) > 0) || (config?.terminalComercial?.gerenciaEstoque == false || config?.terminalComercial?.venderZerado || validarEstoque == false)) ? handleItemPress(item) : window.alert('Produto sem estoque!!'); }}
        //onClick={() => {console.log((config?.terminalComercial?.gerenciaEstoque && parseFloat(item.quantidade_estoque) > 0) || (config?.terminalComercial?.gerenciaEstoque == false ||  config?.terminalComercial?.venderZerado));}}

        style={{ position: 'relative' }}
      >
        <span className="card-text">{item.nome}</span>
        <br />
        <span className="card-text-ean">{item.ean}</span>
        <br />
        <span className="card-text">{formattedPrice}</span>

        <span
          className="card-text-ean"
          style={{
            position: 'absolute',
            right: '10px',
            top: '5%',
          }}
        >
          {item.categoria.nome}
        </span>

        {config?.terminalComercial?.gerenciaEstoque == '1' && (
          <span
            className="card-text"
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)'
            }}
          >
            Qtd: {Number(item.quantidade_estoque || 0).toLocaleString('pt-BR', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2
            })}
          </span>


        )}
      </div>
    );
  };

  return (
    <div className="container-pesquisar">
      <div className="modal-header">
        <Button
          type="primary"
          onClick={closeModal}
          style={{ backgroundColor: "black", borderColor: "black" }}
        >
          <span>Voltar</span>
        </Button>
        <h2>Pesquisar</h2>
      </div>

      <div className="search-container">
        <input
          className="input"
          type="text"
          placeholder="Pesquisar por EAN, Nome ou Código Interno"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (
              e.key === 'Enter' &&
              accessToken &&
              config &&
              (searchTerm || config?.terminalComercial?.pesquisaLivre)
            ) {
              handleSearch();
            }
          }}
        />
        <button
          className="search-button"
          disabled={!accessToken || !config || (!searchTerm && config?.terminalComercial?.pesquisaLivre == false)}
          onClick={handleSearch}
        >
          Pesquisar
        </button>
      </div>

      {isLoading && products.length === 0 ? (
        <Spin
          spinning={isLoading}
          tip={<span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>Carregando...</span>}
          size="large"
        />

      ) : (
        <div className="scroll-container" ref={containerRef}>
          <div className="product-list">
            {products.length > 0 ? (
              products.map(product => (
                <React.Fragment key={product.id}>{renderItem(product)}</React.Fragment>
              ))
            ) : (
              <p className="empty-list-text">Nenhum produto encontrado</p>
            )}
          </div>
          {isLoading && <div className="loading">Carregando...</div>}
          {/* Elemento trigger para o Intersection Observer */}
          <div ref={targetRef} id="scroll-end" style={{ height: '10px' }}></div>
        </div>
      )}
    </div>
  );
};

export default Pesquisar;
